
import { AnalyticsService } from "@/services/analyticsService";

export const useProviderContact = (providerId: string) => {
  const trackContact = (contactType: 'whatsapp' | 'phone' | 'website') => {
    AnalyticsService.trackProviderContact(providerId, contactType);
  };

  return { trackContact };
};
